import * as React from 'react';

const Flag12 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 12 12", width: 12, height: 12, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M1 0h1.5v1h9L9.25 4.75 11.5 8.5h-9V12H1zm1.5 7h6.35l-.89-1.48-.46-.77.46-.77.89-1.48H2.5z"
  }
));
Flag12.Size = 12;
Flag12.Title = "Flag";

export { Flag12 as default };
